import { IOExtension } from 'z3k-config';
export var DeviceModel;
(function (DeviceModel) {
    DeviceModel["H2000_PRO"] = "H2000_PRO";
    DeviceModel["H1500_PRO"] = "H1500_PRO";
    DeviceModel["H700_PRO"] = "H700_PRO";
    DeviceModel["H1000+"] = "H1000+";
    DeviceModel["H1000_PRO"] = "H1000_PRO";
    DeviceModel["H2000+"] = "H2000+";
    DeviceModel["C2000+"] = "C2000+";
    DeviceModel["ZE22"] = "ZE22";
    DeviceModel["ZE44"] = "ZE44";
    DeviceModel["ZE66"] = "ZE66";
    DeviceModel["ZE88"] = "ZE88";
    DeviceModel["ZE8482"] = "ZE8482";
    DeviceModel["CLIMATIC"] = "CLIMATIC";
    DeviceModel["EX77"] = "EX77";
    DeviceModel["ZE00"] = "ZE00";
    DeviceModel["Socket03"] = "Socket03";
})(DeviceModel || (DeviceModel = {}));
export function getIOExtensionModel(type) {
    switch (type) {
        case IOExtension.Type.ZE66:
            return DeviceModel.ZE66;
        case IOExtension.Type.CE_2:
            return DeviceModel.EX77;
        case IOExtension.Type.ZE22:
            return DeviceModel.ZE22;
        case IOExtension.Type.ZE44:
            return DeviceModel.ZE44;
        case IOExtension.Type.ZE88:
            return DeviceModel.ZE88;
        case IOExtension.Type.ZE8482:
            return DeviceModel.ZE8482;
        case IOExtension.Type.HW_ext_board_ZE_00_GATEWAY:
            return DeviceModel.ZE00;
        case IOExtension.Type.HW_ext_board_ZE_03_SOCKETS:
            return DeviceModel.Socket03;
        default:
            return null;
    }
}
export function getIOExtensionUserName(type) {
    switch (type) {
        case IOExtension.Type.ZE66:
            return 'ZE66';
        case IOExtension.Type.CE_2:
            return 'CE_2';
        case IOExtension.Type.HUMIDITY_TEMP_SENSOR:
            return 'Датчик температуры-влажности';
        case IOExtension.Type.TEMP_SENSOR:
            return 'Датчик температуры';
        case IOExtension.Type.BUILTIN_BOARD:
            return 'Сопроцессор ESP';
        case IOExtension.Type.ZE22:
            return 'ZE22';
        case IOExtension.Type.ZE44:
            return 'ZE44';
        case IOExtension.Type.ZE88:
            return 'ZE88';
        case IOExtension.Type.ZE8482:
            return 'ZE8482';
        case IOExtension.Type.HW_ext_board_ZE_00_GATEWAY:
            return 'Шлюз';
        case IOExtension.Type.HW_ext_board_ZE_03_SOCKETS:
            return 'Блок розеток';
        default:
            return '';
    }
}
export function getDeviceModel(type) {
    switch (type) {
        case 'H2000_PRO':
            return DeviceModel.H2000_PRO;
        case 'H1500_PRO':
            return DeviceModel.H1500_PRO;
        case 'H1000_PRO':
            return DeviceModel.H1000_PRO;
        case 'H700_PRO':
            return DeviceModel.H700_PRO;
        case 'H1000+':
            return DeviceModel['H1000+'];
        case 'H2000+':
            return DeviceModel['H2000+'];
        case 'C2000+':
            return DeviceModel['C2000+'];
        case 'CLIMATIC':
        case 'CLIMATIC_PRO':
            return DeviceModel.CLIMATIC;
        default:
            return null;
    }
}
